import styled, { CSSObject, css } from "styled-components";
import { getSizeInPx, getSizeInRem } from "../methods/common";

type FlexPropsType =
    | "margin"
    | "padding"
    | "flexDirection"
    | "flexDirection"
    | "justifyContent"
    | "alignItems"
    | "gap"
    | "rowGap"
    | "flexWrap"
    | "flex"
    | "alignSelf"
    | "display";

const flexStyle = css<Pick<CSSObject, FlexPropsType>>`
    margin: ${({ margin }) => getSizeInRem(margin)};
    padding: ${({ padding }) => getSizeInRem(padding)};
    display: ${({ display }) => (display ? display : "flex")};
    flex-direction: ${({ flexDirection }) => flexDirection ?? "row"};
    justify-content: ${({ justifyContent }) => justifyContent ?? "flex-start"};
    align-items: ${({ alignItems }) => alignItems};
    align-self: ${({ alignSelf }) => alignSelf};
    gap: ${({ gap }) => getSizeInPx(gap)};
    row-gap: ${({ rowGap }) => getSizeInPx(rowGap)};
    flex-wrap: ${({ flexWrap }) => flexWrap ?? "nowrap"};
    flex: ${({ flex }) => flex};
`;

export const Flex = styled.div<Pick<CSSObject, FlexPropsType>>`
    ${flexStyle}
`;

export const VerticalFlex = styled(Flex)`
    ${flexStyle}
    flex-direction: column;
`;

export default Flex;
